import * as firebase from "firebase/app"

var config = {
  apiKey: "AIzaSyBDIKxDrf2VY4VBiVTf7oLvOcqOo4RrRCI",
  authDomain: "crdd-web.firebaseapp.com",
  projectId: "crdd-web",
  storageBucket: "crdd-web.appspot.com",
  messagingSenderId: "639762079164",
  appId: "1:639762079164:web:c7cd0495b6487ca8f79fb9",
  measurementId: "G-NEV4JTFD50"
};
let firebaseConfig = firebase.initializeApp(config);
export default firebaseConfig;
